import React, { memo, useCallback, useMemo } from 'react'

import i18n from '@batical/i18n'
import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'
import { FaChevronRight } from 'react-icons/fa'

import { ViewLine, CalculText, CalculTextRight, ViewDisclosure } from './LineStyleComponent'

export type TextValueProps = {
  value?: number
  calculCode: CalculCodeStateKeys
  variableName: string
  trunc: number
  unit?: string
  disclosure?: boolean
  onPress?: (variableName: string) => void
  first?: boolean
  last?: boolean
}
const TextValue = ({
  calculCode,
  variableName,
  value,
  trunc = 2,
  unit = '',
  disclosure = false,
  onPress,
  first = false,
  last = false
}: TextValueProps) => {
  const valueRedux = useContextValue(variableName, calculCode)[0]

  const valueFinal = useMemo(() => {
    return value ?? valueRedux ?? 0
  }, [value, valueRedux])

  const text = useMemo(() => {
    let tex = i18n.t(`${calculCode}_${variableName}`)
    if (unit) {
      tex += ` [${unit}]`
    }
    return tex
  }, [calculCode, unit, variableName])

  const _onPress = useCallback(() => {
    if (onPress) {
      onPress(variableName)
    }
  }, [onPress, variableName])

  return (
    <ViewLine first={first} last={last} onClick={_onPress}>
      <CalculText>{text}</CalculText>
      <ViewDisclosure>
        <CalculTextRight>{+valueFinal.toFixed(trunc)}</CalculTextRight>
        {disclosure && <FaChevronRight color="#808080" size={25} />}
      </ViewDisclosure>
    </ViewLine>
  )
}

export default memo(TextValue)
